import React from 'react';
import { useSubscription } from '../contexts/SubscriptionContext';

interface PaymentFailureBannerProps {
  onUpdatePayment: () => void;
}

const PaymentFailureBanner: React.FC<PaymentFailureBannerProps> = ({ onUpdatePayment }) => {
  const { subscription } = useSubscription();

  if (!subscription || (subscription.status !== 'past_due' && subscription.status !== 'unpaid')) {
    return null;
  }

  const isPastDue = subscription.status === 'past_due';
  const isUnpaid = subscription.status === 'unpaid';

  return (
    <div className="bg-red-50 border-b border-red-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-red-800">
                {isPastDue 
                  ? 'Payment Failed - Action Required'
                  : 'Subscription Suspended - Payment Required'
                }
              </p>
              <p className="text-sm text-red-700">
                {isPastDue 
                  ? 'Your payment was unsuccessful. Please update your payment method to continue your subscription.'
                  : 'Your subscription has been suspended due to payment failure. Please update your payment method to reactivate.'
                }
              </p>
            </div>
          </div>
          <div className="flex-shrink-0">
            <button
              onClick={onUpdatePayment}
              className="bg-red-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-red-700 transition-colors"
            >
              {isPastDue ? 'Update Payment' : 'Reactivate'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailureBanner; 